import { Modal, ModalContent } from '@nextui-org/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Crown } from 'lucide-react';

import { trackEvent } from '../utils/gt';

// trialEnd: the formatted day a trial started at checkout runs to (its first charge), when it's one
export const ModalProSuccess = ({ isOpen, onOpenChange, onClose, trialEnd = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      isDismissable={false}
      hideCloseButton
      classNames={{ base: 'mt-root mt-dialog mt-promo mt-promo--welcome', backdrop: 'mt-dialog__backdrop' }}
    >
      <ModalContent>
        {() => (
          <div className="mt-dialog__body mt-promo__body">
            <span className="mt-promo__seal" aria-hidden="true">
              <Crown />
            </span>
            <h2 className="mt-dialog__title">{t('components.ModalProSuccess.title')}</h2>
            <p className="mt-dialog__text">
              {trialEnd
                ? t('components.ModalProSuccess.descTrial', { date: trialEnd })
                : t('components.ModalProSuccess.desc')}
            </p>
            <div className="mt-promo__actions">
              <button
                type="button"
                className="mt-btn mt-btn--primary"
                onClick={() => {
                  trackEvent('modal_pro_success_cta', 'Modal Pro Success - Get Started', 'modal_pro_success', true);
                  onClose();
                  navigate('/dashboard');
                }}
              >
                {t('components.ModalProSuccess.cta')}
              </button>
            </div>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
};
